import { getQueryString } from '@utils';

const city = localStorage.getItem('city') ? localStorage.getItem('city').split(',')[0] : getQueryString('city') ? getQueryString('city') : '145';
const initialState = {
  LinkResult: {
    menuItems: [
      {
        name: '电影',
        isShow: 0,
        url: `${window.location.origin}/newmovie/`,
      },
      // {
      //   name: '演出',
      //   isShow: 0,
      //   url: `${window.location.origin}/scenery/list`,
      // },
      // {
      //   name: '旅游景点',
      //   isShow: 0,
      //   url: `${window.location.origin}/scenery/list`,
      // },
      {
        name: '健康生活',
        isShow: 0,
        url: `${window.location.origin}/wap/health/index?city=${city}`,
      },
      {
        name: '生日汇',
        isShow: 0,
        // url: `${window.location.origin}/birthday/home?city=${city}`,
        url: `${window.location.origin}/newBirthday?city=${city}`,
      },
      {
        name: '优选生活',
        isShow: 0,
        url: `${window.location.origin}/shopping/home?city=${city}`,
      },
      {
        name: '节日礼包',
        isShow: 0,
        url: `${window.location.origin}/spree/list?city=${city}`,
      },
      {
        name: '企业活动',
        isShow: 0,
        url: `${window.location.origin}/common/activity/home?city=${city}`,
      },
    ],
  },
};

// 取消订单参数
export default function getLink(state = initialState, action) {
  switch (action.type) {
  case 'GET_LINK':
    return { ...state, LinkResult: action.payload };
  default:
    return state;
  }
}